import { render, staticRenderFns } from "./EditPrescription.vue?vue&type=template&id=902f0f52&scoped=true"
import script from "./EditPrescription.vue?vue&type=script&lang=js"
export * from "./EditPrescription.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "902f0f52",
  null
  
)

export default component.exports